import { render, staticRenderFns } from "./req-buy.vue?vue&type=template&id=49cb3c36&scoped=true"
import script from "./req-buy.vue?vue&type=script&lang=js"
export * from "./req-buy.vue?vue&type=script&lang=js"
import style0 from "./req-buy.vue?vue&type=style&index=0&id=49cb3c36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cb3c36",
  null
  
)

export default component.exports